<template>
  <div
    class="search-bar"
    :style="{ width: width }"
    :data-testid="`${dataTestidPrefix}__container`"
  >
    <img
      src="/img/icons/fbc-icons/SearchIcon.svg"
      alt=""
      class="search-bar__icon"
      :data-testid="`${dataTestidPrefix}__icon`"
    />
    <lb-string
      label=""
      :placeholder="placeholder"
      :value="localValue"
      :isClearable="true"
      hidedetails
      :disabled="disabled"
      :data-testid="`${dataTestidPrefix}__input`"
      @input="onInput"
      class="search-bar__input"
    />
  </div>
</template>

<script>
/**
 * SearchBar — debounced toolbar search input.
 *
 * @example
 * <SearchBar v-model="search" placeholder="Search" />
 */
export default {
  name: 'SearchBar',

  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
    debounceMs: {
      type: Number,
      default: 300,
    },
    dataTestidPrefix: {
      type: String,
      default: 'search-bar',
    },
    width: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localValue: this.value || '',
      debounceTimer: null,
    };
  },

  watch: {
    value(next) {
      if (next !== this.localValue) {
        this.localValue = next || '';
      }
    },
  },

  beforeDestroy() {
    this.clearDebounce();
  },

  methods: {
    clearDebounce() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
    },

    onInput(next) {
      this.localValue = next == null ? '' : String(next);
      this.clearDebounce();

      if (this.debounceMs <= 0) {
        this.$emit('input', this.localValue);
        return;
      }

      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;
        this.$emit('input', this.localValue);
      }, this.debounceMs);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './SearchBar.scss';
</style>
